class MacroCalculator {
  constructor() {
    this.data = {
      ft: [], // Feet
      in: [], // Inches
      cm: [], // Centimeters
      crb: [], // Carbs
      pro: [], // Proteins
      fat: [], // Fats
      macroRatio: [],
    };

    this.currentValues = {
      gender: 'male',
      age: 17,
      ft: 6,
      in: 0,
      cm: 182,
      lbs: 0,
      kg: 0,
      CRB: 45,
      PRO: 30,
      FAT: 25,
      MACRORATIO: 100,
      useHeight: false,
      useWeight: false,
      useBodyFat: false,
      bodyFat: 0,
      targetWeight: 0,
      targetWeightLbs: 0,
      targetWeeks: 0,
      selectedGoal: "muscle-gain",
      selectedExercise: 3,
      selectedAlternateEvent: null,
      BMR: null,
      TDEE: null,
      targetCalories: null,
    };

    this.exerciseDetails = {
      1: 'Sedentary (Little to no exercise)',
      2: 'Light exercise (1-3 days per week)',
      3: 'Moderate exercise (3-5 days per week)',
      4: 'Hard exercise (6-7 days per week)',
      5: 'Very intense exercise (Beyond standard hours of exercise per day)'
    };

    this.exerciseColors = {
      1: 'rgb(240 130 60)',
      2: 'rgb(220 115 45)',
      3: 'rgb(200 100 30)',
      4: 'rgb(180 85 15)',
      5: 'rgb(160 70 0)'
    };

    this.macroColors = {
      CRB: "#b1e7e7",
      PRO: "#db7603",
      FAT: "#eff310"
    };

    this.activityMultipliers = {
      1: 1.2,
      2: 1.375,
      3: 1.55,
      4: 1.725,
      5: 1.9
    };

    this.bodyFatDetailLabels = {
      0: 'Essential Fat',
      1: 'Athletes',
      2: 'Fitness',
      3: 'Average',
      4: 'Obese'
    };

    this.bodyFatDetails = {
      'male': {
        0: 'Minimum for survival; too low long-term can damage hormones/health.',
        1: 'Common in endurance athletes, tactical athletes, and bodybuilders (competition ~5–8%).',
        2: 'Lean, muscular, good performance range; sustainable.',
        3: 'Healthy but softer appearance; performance not maximized.',
        4: 'Increased health risks, reduced performance.'
      },
      'female': {
        0: 'Required for hormone function and survival.',
        1: 'Very lean, common in competitive athletes.',
        2: 'Lean and healthy, good for performance.',
        3: 'Normal range, not performance-focused.',
        4: 'Increased health risks, reduced performance.'
      }
    };

    this.bodyFatRateMale = {
      0: 0,
      1: 6,
      2: 14,
      3: 18,
      4: 25
    };

    this.bodyFatRateFemale = {
      0: 0,
      1: 14,
      2: 21,
      3: 25,
      4: 32
    };

    this.scores = {
      CRB: 0,
      PRO: 0,
      FAT: 0,
      MACRORATIO: 0
    };

    this.isUpdatingFromInput = false;

    this.donutLayout = {
      /*title: {
        text: 'Macros',
        y: 0.1,
      },*/
      paper_bgcolor: 'transparent',
      annotations: [
        {
          font: {
            size: 20
          },
          showarrow: false,
          text: '',
          x: 0.17,
          y: 0.5
        }
      ],
      margin: {
        t: 1,
        //b: 100,
        l:1,
        r:1,
        pad: 50,
      },
      automargin: false,
      autosize: true,
      height: 300,
      //minreducedwidth: 200,
      width: parseInt(Math.floor($(".macro-chart-container").width())),
      showlegend: false
    };

    this.init();
  }

  async init() {
    console.log('Starting Macro Calculator initialization...');

    try {
      await this.loadAllData();
      await this.waitForDOM();
      this.toggleHeightInputs(this.currentValues.useHeight);
      this.toggleWeightInputs(this.currentValues.useWeight);
      this.toggleGoals(this.currentValues.selectedGoal);
      this.toggleExercise(this.currentValues.selectedExercise);
      //this.setupSliders();
      this.setupEventListeners();
      this.setupRatios();
      //this.updateAllScores();
      console.log('Macro Calculator initialized');
    } catch (error) {
      console.error('Error initializing Macro Calculator:', error);
    }
  }

  async loadAllData() {
    try {
      /*const [mdlData, hrpData, sdcData, plkData, runData, alternateRunsData] = await Promise.all([
        fetch('{{'mdl.json' | asset_url }}').then(r => r.json()),
        fetch('{{'hrp.json' | asset_url }}').then(r => r.json()),
        fetch('{{'scp.json' | asset_url }}').then(r => r.json()),
        fetch('{{'plk.json' | asset_url }}').then(r => r.json()),
        fetch('{{'2mr.json' | asset_url }}').then(r => r.json()),
        fetch('{{ 'alternate.json' | asset_url }}').then(r => r.json())
      ]);*/

      /*this.data.mdl = mdlData;
      this.data.hrp = hrpData;
      this.data.sdc = sdcData;
      this.data.plk = plkData;
      this.data.run = runData;
      this.data.alternateRuns = alternateRunsData;*/

      /*console.log('Loaded alternate runs data:', {
        hasData: !!this.data.alternateRuns,
        length: this.data.alternateRuns?.length,
        firstGroup: this.data.alternateRuns?.[0]
      });*/
    } catch (error) {
      console.error('Error loading data:', error);
      throw error;
    }
  }

  waitForDOM() {
    return new Promise((resolve) => {
      const checkDOM = () => {
        const requiredElements = [
          'select[name="gender"]',
          /*'[data-field-id="CRB"] .slider',
          '[data-field-id="PRO"] .slider',
          '[data-field-id="FAT"] .slider'*/
        ];

        const allExists = requiredElements.every(selector =>
          document.querySelector(selector) !== null
        );

        if (allExists) {
          resolve();
        } else {
          setTimeout(checkDOM, 100);
        }
      };
      checkDOM();
    });
  }

  checkAge() {
    if (!($('input[name="age"]').val())) {
      this.currentValues.age = 0;
    } else {
      this.currentValues.age = parseInt($('input[name="age"]').val());
    }
  }

  checkHeight() {
    if (!!($('input[name="height-feet"]').val()) && !!($('input[name="height-inches"]').val()) && !!($('div[data-option-id="ft"]').hasClass('event-selected'))) {
      this.currentValues.ft = parseInt($('input[name="height-feet"]').val());
      this.currentValues.in = parseInt($('input[name="height-inches"]').val());
      this.currentValues.cm = (parseFloat($('input[name="height-feet"]').val() * 12) + parseFloat($('input[name="height-inches"]').val())) * 2.54;
    } else if (!!($('input[name="height-centimeters"]').val()) && !!($('div[data-option-id="cm"]').hasClass('event-selected'))) {
      this.currentValues.cm = parseFloat($('input[name="height-centimeters"]').val());
    } else {
      this.currentValues.cm = null;
    }
  }

  checkWeight() {
    if (!!($('input[name="weight-pounds"]').val()) && !!($('div[data-option-id="lbs"]').hasClass('event-selected'))) {
      this.currentValues.lbs = parseInt($('input[name="weight-pounds"]').val());
      this.currentValues.kg = parseFloat((parseFloat($('input[name="weight-pounds"]').val())) / 2.205);
    } else if (!!($('input[name="weight-kilograms"]').val()) && !!($('div[data-option-id="kg"]').hasClass('event-selected'))) {
      this.currentValues.kg = (parseFloat($('input[name="weight-kilograms"]').val()));
    } else {
      this.currentValues.kg = null;
    }
  }

  checkTargetWeight() {
    if (!!($('input[name="goal-pounds"]').val()) && !!($('div[data-option-id="lbs"]').hasClass('event-selected'))) {
      this.currentValues.targetWeightLbs = parseInt($('input[name="goal-pounds"]').val());
      this.currentValues.targetWeight = parseFloat((parseFloat($('input[name="goal-pounds"]').val())) / 2.205);
    } else if (!!($('input[name="goal-kilograms"]').val()) && !!($('div[data-option-id="kg"]').hasClass('event-selected'))) {
      this.currentValues.targetWeight = (parseFloat($('input[name="goal-kilograms"]').val()));
    } else {
      this.currentValues.targetWeight = null;
    }

    console.log("Target Weight: " + this.currentValues.targetWeight);

    this.checkCalorieGoal();
  }

  checkTargetWeeks() {
    if (!!($('input[name="goal-weeks"]').val())) {
      this.currentValues.targetWeeks = parseInt($('input[name="goal-weeks"]').val());
    } else {
      this.currentValues.targetWeeks = null;
    }

    console.log("Target Weeks: " + this.currentValues.targetWeeks);

    this.checkCalorieGoal();
  }

  checkBMR() {
    let genderResult = this.currentValues.gender;
    if (!!this.currentValues.age && !!this.currentValues.cm && !!this.currentValues.kg) {
      this.currentValues.BMR = parseFloat(((genderResult == "male") ? (88.362 + (13.397 * this.currentValues.kg) + (4.799 * this.currentValues.cm) - (5.677 * this.currentValues.age)) : (447.593 + (9.247 * this.currentValues.kg) + (3.098 * this.currentValues.cm) - (4.33 * this.currentValues.age))).toFixed(2));
    } else {
      this.currentValues.BMR = null;
    }
    console.log("BMR: " + this.currentValues.BMR);

    this.checkTDEE();
  }

  checkTDEE() {
    if (!!this.currentValues.BMR) {
      let bmrResult = this.currentValues.BMR;
      let activityMultiplierResult = this.activityMultipliers[this.currentValues.selectedExercise];
      let dailyRequirementResult = parseFloat((bmrResult * activityMultiplierResult).toFixed(2));

      this.currentValues.TDEE = dailyRequirementResult;
    } else {
      this.currentValues.TDEE = null;
    }
    console.log("TDEE: " + this.currentValues.TDEE);
    this.checkCalorieGoal();
  }

  checkCalorieGoal() {
    let goalAmount;
    let dailyAmt;
    let calorieAmt;
    let newDailyCalories;

    if (this.currentValues.selectedGoal == "weight-loss") {
      if (!!this.currentValues.TDEE && !!this.currentValues.targetWeeks && !!this.currentValues.targetWeight) {
        goalAmount = this.currentValues.kg - this.currentValues.targetWeight;
        if (goalAmount >= 0) {
          dailyAmt = goalAmount / ((this.currentValues.targetWeeks > 0) ? (this.currentValues.targetWeeks * 7) : 7);
          console.log("Daily amt: " + dailyAmt);
          let dailyCheck = dailyAmt * 7 * 2.205;
          if (dailyCheck <= 2) {
            $(".weekly-warning-container").css("display", "none");
          } else {
            $(".weekly-warning-container").css("display", "block");
            $(".warning-loss").css("display", "block");
            $(".warning-gain").css("display", "none");
          }
          calorieAmt = Math.round((this.currentValues.TDEE * 0.2) * (dailyAmt * 2.205));
          newDailyCalories = this.currentValues.TDEE - calorieAmt;
          $(".macro-recommend-button").prop("disabled", false);
        } else {
          newDailyCalories = null;
          $(".macro-recommend-button").prop("disabled", true);
          $(".weekly-warning-container").css("display", "none");
        }
      } else {
        $(".macro-recommend-button").prop("disabled", true);
        $(".weekly-warning-container").css("display", "none");
      }
    } else if (this.currentValues.selectedGoal == "muscle-gain") {
      if (!!this.currentValues.TDEE && !!this.currentValues.targetWeeks && !!this.currentValues.targetWeight) {
        goalAmount = this.currentValues.targetWeight - this.currentValues.kg;
        if (goalAmount >= 0) {
          dailyAmt = goalAmount / ((this.currentValues.targetWeeks > 0) ? (this.currentValues.targetWeeks * 7) : 7);
          console.log("Daily amt: " + dailyAmt);
          let dailyCheck = dailyAmt * 7 * 2.205;
          if (dailyCheck <= 2) {
            $(".weekly-warning-container").css("display", "none");
          } else {
            $(".weekly-warning-container").css("display", "block");
            $(".warning-loss").css("display", "none");
            $(".warning-gain").css("display", "block");
          }
          calorieAmt = Math.round((this.currentValues.TDEE * 0.2) * (dailyAmt * 2.205));
          newDailyCalories = this.currentValues.TDEE + calorieAmt;
          $(".macro-recommend-button").prop("disabled", false);
        } else {
          newDailyCalories = null;
          $(".macro-recommend-button").prop("disabled", "true");
          $(".weekly-warning-container").css("display", "none");
        }
      } else {
        $(".macro-recommend-button").prop("disabled", true);
        $(".weekly-warning-container").css("display", "none");
      }
    } else if (this.currentValues.selectedGoal == "body-recomp-route") {
      if (!!this.currentValues.TDEE && !!this.currentValues.targetWeeks && !!this.currentValues.targetWeight && !!this.currentValues.bodyFat) {
        goalAmount = this.currentValues.kg - this.currentValues.targetWeight;
        let newBMR = 370 + (21.6 * (this.currentValues.kg * (1 - (this.currentValues.bodyFat / 100))));
        let activityMultiplierResult = this.activityMultipliers[this.currentValues.selectedExercise];
        let newTDEE = parseFloat((newBMR * activityMultiplierResult).toFixed(2));

        if (goalAmount >= 0) {
          dailyAmt = goalAmount / ((this.currentValues.targetWeeks > 0) ? (this.currentValues.targetWeeks * 7) : 7);
          console.log("Daily amt: " + dailyAmt);
          let dailyCheck = dailyAmt * 7 * 2.205;
          if (dailyCheck <= 2) {
            $(".weekly-warning-container").css("display", "none");
          } else {
            $(".weekly-warning-container").css("display", "block");
            $(".warning-loss").css("display", "block");
            $(".warning-gain").css("display", "none");
          }
          calorieAmt = Math.round((newTDEE * 0.2) * (dailyAmt * 2.205));
          newDailyCalories = newTDEE - calorieAmt;
          $(".macro-recommend-button").prop("disabled", false);
        } else {
          newDailyCalories = null;
          $(".macro-recommend-button").prop("disabled", true);
          $(".weekly-warning-container").css("display", "none");
        }
      } else {
        $(".macro-recommend-button").prop("disabled", true);
        $(".weekly-warning-container").css("display", "none");
      }
    } else {
      newDailyCalories = null;
      $(".macro-recommend-button").prop("disabled", true);
    }

    if (!!newDailyCalories) {
      console.log("New Daily Calorie Amount: " + newDailyCalories + " calories per day");
      this.currentValues.targetCalories = parseInt(Math.round(newDailyCalories));
    } else {
      this.currentValues.targetCalories = null;
    }
    /*
    let newCarbAmt = (newDailyCalories * (this.currentValues.CRB / 100)) / 4;
    let newProteinAmt = (newDailyCalories * (this.currentValues.PRO / 100)) / 4;
    let newFatAmt = (newDailyCalories * (this.currentValues.FAT / 100)) / 9;

    console.log("BMR: " + bmrResult);
    console.log("Activity Multiplier: " + activityMultiplierResult);
    console.log("Daily Requirement: " + dailyRequirementResult);
    console.log("Daily Amount: " + dailyAmt + " kgs per day");
    console.log("Daily Amount: " + dailyAmtLbs + " lbs per day");
    console.log("Subtracted Calorie Amount: " + calorieAmt + " calories per day");
    console.log("New Daily Calorie Amount: " + newDailyCalories + " calories per day");
    console.log("Daily Carbs: " + newCarbAmt + " grams per day");
    console.log("Daily Proteins: " + newProteinAmt + " grams per day");
    console.log("Daily Fats: " + newFatAmt + " grams per day");
    */

    this.reviewData();
  }

  setupRatios() {
    this.setupValidValueRatio('carb');
    this.setupValidValueRatio('protein');
    this.setupValidValueRatio('fat');

    const carbSelect = document.querySelector('input[name="carb-percent"]');
    const proteinSelect = document.querySelector('input[name="protein-percent"]');
    const fatSelect = document.querySelector('input[name="fat-percent"]');
    
    let rTotal;

    // [Ratio Listener]
    if (carbSelect) {
      carbSelect.addEventListener('input', (e) => {
        this.currentValues.CRB = parseInt(e.target.value);
        this.checkRatioTotal();
      });
    }

    if (proteinSelect) {
      proteinSelect.addEventListener('input', (e) => {
        this.currentValues.PRO = parseInt(e.target.value);
        this.checkRatioTotal();
      });
    }

    if (fatSelect) {
      fatSelect.addEventListener('input', (e) => {
       this.currentValues.FAT = parseInt(e.target.value);
       this.checkRatioTotal();
      });
    }

    var donutData = [{
      values: [this.currentValues.CRB, this.currentValues.PRO, this.currentValues.FAT],
      labels: ['Carbs', 'Proteins', 'Fats' ],
      marker: { colors: ['#ff7733', '#cc0000', '#880022']},
      domain: {column: 0},
      sort: false, 
      name: 'Macronutrient Ratio',
      textinfo: 'label+percent',
      hoverinfo: 'label+percent',
      hole: .4,
      pull: 0.02,
      type: 'pie'
    }];

    Plotly.newPlot('macroRatioChart', donutData, this.donutLayout);

    this.checkRatioTotal();
  }

  checkRatioTotal() {
    if ((parseFloat(this.currentValues.FAT) + parseFloat(this.currentValues.CRB) + parseFloat(this.currentValues.PRO)) == 100) {

      this.currentValues.MACRORATIO = 100;

      $(".macro-chart-cover").css("display", "none");
      $(".macro-chart-container").css("display", "block");

      let newDonutData = [{
        values: [this.currentValues.CRB, this.currentValues.PRO, this.currentValues.FAT],
        labels: ['Carbs', 'Proteins', 'Fats' ],
        marker: { colors: ['#ff7733', '#cc0000', '#880022']},
        domain: {column: 0},
        sort: false, 
        name: 'Macronutrient Ratio',
        textinfo: 'label+percent',
        hoverinfo: 'label+percent',
        hole: .4,
        pull: 0.02,
        type: 'pie'
      }];

      let newDonutLayout = {
        paper_bgcolor: 'transparent',
        annotations: [
          {
            font: {
              size: 20
            },
            showarrow: false,
            text: '',
            x: 0.17,
            y: 0.5
          }
        ],
        margin: {
          t: 1,
          l:1,
          r:1,
          pad: 50,
        },
        automargin: false,
        autosize: true,
        height: 300,
        width: parseInt(Math.floor($(".macro-chart-container").width())),
        showlegend: false
      };

      Plotly.newPlot('macroRatioChart', newDonutData, newDonutLayout);
      Plotly.redraw('macroRatioChart');



      this.reviewData();
    } else {
      this.currentValues.MACRORATIO = (parseFloat(this.currentValues.FAT) + parseFloat(this.currentValues.CRB) + parseFloat(this.currentValues.PRO));
      $(".macro-chart-cover").css("display", "block");
      $(".macro-chart-container").css("display", "none");
      this.reviewData();
    }
  }

  setupSliders() {
    this.setupValidValueSlider('CRB');
    this.setupValidValueSlider('PRO');
    this.setupValidValueSlider('FAT');

    this.setupMacroRatioTotal();

    //this.setupSPTSlider();
  }

  setupValidValueRatio(fieldName) {
    const inputElement = document.querySelector(`input[name="${fieldName}-percent"]`);

    let data;
    let macColor;
    switch (fieldName) {
      case 'carb': 
        data = this.data.crb;
        break;
      case 'protein': 
        data = this.data.pro;
        break;
      case 'fat': 
        data = this.data.fat;
        break;
      default: return;
    }

    let currentData;
    switch (fieldName) {
      case 'carb': currentData = this.currentValues.CRB; break;
      case 'protein': currentData = this.currentValues.PRO; break;
      case 'fat': currentData = this.currentValues.FAT; break;
      default: return;
    }

    inputElement.value = currentData;

    const validValues = Array.from({ length: 101 }, (value, index) => index);

    if (validValues.length === 0) {
      console.warn(`Tidak ada nilai valid untuk ${fieldName}`);
      return;
    }
  }

  setupValidValueSlider(fieldName) {
    const sliderElement = document.querySelector(`[data-field-id="${fieldName}"] .slider`);
    const inputElement = document.querySelector(`input[name="${fieldName}"]`);
    
    let sliderElementColor = document.querySelector(`.maa-${fieldName}`);

    if (!sliderElement || !window.noUiSlider) return;

    let data;
    let macColor;
    switch (fieldName) {
      case 'CRB': 
        data = this.data.crb;
        macColor = this.macroColors.CRB;
        break;
      case 'PRO': 
        data = this.data.pro;
        macColor = this.macroColors.PRO;
        break;
      case 'FAT': 
        data = this.data.fat;
        macColor = this.macroColors.FAT;
        break;
      default: return;
    }

    let currentData;
    switch (fieldName) {
      case 'CRB': currentData = this.currentValues.CRB; break;
      case 'PRO': currentData = this.currentValues.PRO; break;
      case 'FAT': currentData = this.currentValues.FAT; break;
      default: return;
    }

    const validValues = Array.from({ length: 101 }, (value, index) => index);

    if (validValues.length === 0) {
      console.warn(`Tidak ada nilai valid untuk ${fieldName}`);
      return;
    }

    const minValue = validValues[0];
    const maxValue = validValues[validValues.length - 1];

    const validValuesArray = validValues.map(item => item);

    if (sliderElement.noUiSlider) {
      try {
        // Coba update range tanpa destroy
        sliderElement.noUiSlider.updateOptions({
          range: {
            'min': minValue,
            'max': maxValue
          },
          start: [minValue],
          step: 1,
          format: {
            to: function (value) {
                return Math.round(value);
            },
            from: function (value) {
              return Number(value);
            }
          }
        }, true); 

        // Update current value
        this.currentValues[fieldName] = minValue;
        if (inputElement) {
          inputElement.value = Math.round(minValue);
        }
        this.updateScore(fieldName);

        console.log(`Slider ${fieldName} berhasil diupdate dengan ${validValues.length} nilai valid (${minValue}-${maxValue})`);
        return; // Keluar jika berhasil update
      } catch (error) {
        console.log(`Update gagal untuk ${fieldName}, akan destroy dan create ulang: ${error.message}`);
        // Lanjut ke destroy jika update gagal
      }
    }

    // Jika slider belum ada atau update gagal, destroy dan create ulang
    if (sliderElement.noUiSlider) {
      try {
        sliderElement.noUiSlider.destroy();
        const origins = sliderElement.querySelectorAll('.noUi-origin');
        origins.forEach(origin => {
          origin.style.transform = 'translate(0%, 0px)';
        });

        console.log(`Slider ${fieldName} berhasil dihancurkan`);
      } catch (error) {
        console.error(`Error menghancurkan slider ${fieldName}:`, error);
        sliderElement.innerHTML = '';
        sliderElement.className = 'slider';
      }
    }

    // Create slider baru
    try {
      noUiSlider.create(sliderElement, {
        start: [currentData],
        connect: [true, false],
        range: {
          'min': minValue,
          'max': maxValue
        },
        step: 1,
        format: {
          to: function (value) {
            return Math.round(value);
          },
          from: function (value) {
            return Number(value);
          }
        }
      });

      $("div").find('[data-field-id="'+fieldName+'"] > div > div > div > div').last().find('.noUi-connect').last().css("background-color", macColor);
 
      // Event listener untuk slider
      sliderElement.noUiSlider.on('update', (values) => {
        const value = parseFloat(values[0]);
        this.currentValues[fieldName] = value;

        if (inputElement && !this.isUpdatingFromInput) {
          inputElement.value = Math.round(value);
        }

        this.updateScore(fieldName);

        this.updateTotalRatio();
      });


      // Event listener untuk input
      if (inputElement) {
        inputElement.addEventListener('change', () => {
          const value = parseFloat(inputElement.value) || minValue;

          // Cari nilai valid terdekat
          let snappedValue = validValuesArray[0]; // Default ke nilai terkecil
          for (let i = validValuesArray.length - 1; i >= 0; i--) { // Iterasi dari terbesar ke terkecil
            if (value >= validValuesArray[i]) {
              snappedValue = validValuesArray[i];
              break;
            }
          }

          console.log("snap");

          this.isUpdatingFromInput = true;
          sliderElement.noUiSlider.set(snappedValue);
          this.isUpdatingFromInput = false;
          
        });
      }

      console.log(`Slider ${fieldName} berhasil dibuat dengan ${validValues.length} nilai valid (${minValue}-${maxValue})`);
    } catch (error) {
      console.error(`Error membuat slider ${fieldName}:`, error);
    }
  }

  setupMacroRatioTotal() {
    const sliderElement = document.querySelector(`[data-field-id="MACRORATIO"] .macro-ratio-check-base`);
    
    let underRatioColor = '#bbbbbb';
    let perfectRatioColor = '#00bb00';

    if (!sliderElement || !window.noUiSlider) return;

    let data;
    let macColor;

    data = this.data.macroRatio;
    macColor = perfectRatioColor;

    let currentData;
    currentData = this.currentValues.MACRORATIO;

    let crbData = this.currentValues.CRB;
    let proData = this.currentValues.PRO;
    let fatData = this.currentValues.FAT;

    const validValues = Array.from({ length: 101 }, (value, index) => index);

    console.log(validValues);

    if (validValues.length === 0) {
      console.warn(`Tidak ada nilai valid untuk`);
      return;
    }

    this.updateTotalRatio();
  }

  updateScore(fieldName) {
    if (fieldName === 'SPT') {
      return;
    }

    let points = 0;
    let statusText = '';

    switch (fieldName) {
      case 'CRB':
        points = this.calculateCRBPoints(this.currentValues.CRB);
        break;
      case 'PRO':
        points = this.calculatePROPoints(this.currentValues.PRO);
        break;
      case 'FAT':
        points = this.calculateFATPoints(this.currentValues.FAT);
        break;
    }

    this.scores[fieldName] = points;

    // Update tampilan points
    let pointsElement = document.querySelector(`[data-field-id="${fieldName}"] .form-field__percents-value`);
    let statusElement;
    pointsElement = document.querySelector(`[data-field-id="${fieldName}"] .form-field__percents-value`);

    if (pointsElement) {
      pointsElement.textContent = points;
    }

    //console.log(`${fieldName} points updated: ${points}`);
  }

  updateTotalRatio() {

    let points = 0;
    let statusText = '';

    points = this.currentValues.CRB + this.currentValues.PRO + this.currentValues.FAT;

    this.scores.MACRORATIO = points;

    if (this.scores.MACRORATIO == 100) {
      $(".macro-ratio-connect").css("background-color", "rgb(174 235 174)");
    } else {
      $(".macro-ratio-connect").css("background-color", "#bbbbbb");
    }

    if (this.scores.MACRORATIO >= 100) {
      $(".macro-ratio-connect").css("transform", "translate(0%, 0px) scale(1, 1)");
    } else {
      $(".macro-ratio-connect").css("transform", "translate(" + ((100 - this.scores.MACRORATIO) / -2) + "%, 0px) scale(" + (this.scores.MACRORATIO / 100) + ", 1)");
    }

    let pointsElement = document.querySelector(`[data-field-id="MACRORATIO"] .form-field__ratio-value`);
    let statusElement;
    pointsElement = document.querySelector(`[data-field-id="MACRORATIO"] .form-field__ratio-value`);

    if (pointsElement) {
      pointsElement.textContent = points;
    }
  }

  refreshRatios() {
    let proteinSet = 0;
    let carbSet = 0;
    let fatSet = 0;
    console.log("Refreshing...");
    if (!!this.currentValues.targetCalories) {
      console.log("TDEE Set: " + this.currentValues.targetCalories);
      //if (this.currentValues.selectedGoal == 'muscle-gain' || this.currentValues.selectedGoal == 'weight-loss') {
        console.log("Goal Set: " + this.currentValues.selectedGoal);
        if (!!this.currentValues.kg) {
          console.log("Weight Set: " + this.currentValues.kg);
          console.log("Activity: " + this.activityMultipliers[this.currentValues.selectedExercise]);
          //proteinSet = ((this.currentValues.kg * 2.205) / 1.9 * this.activityMultipliers[this.currentValues.selectedExercise] * (this.activityMultipliers[this.currentValues.selectedExercise] - ((this.activityMultipliers[this.currentValues.selectedExercise] - 1) / 2)) * 4);
          //proteinSet = ((this.currentValues.kg * 2.205) * 0.68 * 4);
          proteinSet = ((this.currentValues.kg * 2.205) * (((0.125 * (this.currentValues.selectedExercise - 1) + 1.2)) * 0.8) * 4);
          console.log("Protein Set: " + proteinSet);
          fatSet = this.currentValues.targetCalories * 0.25;
          //fatSet = ((this.currentValues.kg * 2.205) * 0.4 * 9);
          carbSet = this.currentValues.targetCalories - fatSet - proteinSet;

          this.currentValues.PRO = parseInt(Math.round(proteinSet / this.currentValues.targetCalories  * 100));
          this.currentValues.FAT = parseInt(Math.round(fatSet / this.currentValues.targetCalories * 100));
          this.currentValues.CRB = 100 - this.currentValues.PRO - this.currentValues.FAT;

          console.log("Total PRO: " + this.currentValues.PRO);
          console.log("Total FAT: " + this.currentValues.FAT);
          console.log("Total CRB: " + this.currentValues.CRB);

          let totalRatioSet = this.currentValues.CRB + this.currentValues.PRO + this.currentValues.FAT;

          console.log("Total Ratio Set: " + totalRatioSet);

          if (totalRatioSet < 100) {
            let counter = 100;
            let carbChoice = 0;
            while (totalRatioSet < 100 && counter > 0) {
              switch (carbChoice) {
                case 0:
                  this.currentValues.CARB++;
                  break;
                case 1:
                  this.currentValues.FAT++;
                  break;
                case 2:
                  this.currentValues.PRO++;
                  break;
              }
              carbChoice++;
              carbChoice = carbChoice % 3;
              totalRatioSet++;
              counter--;
            }
          } else if (totalRatioSet > 100) {
            let counter = 100;
            let carbChoice = 0;
            while (totalRatioSet > 100 && counter > 0) {
              switch (carbChoice) {
                case 0:
                  this.currentValues.CARB--;
                  break;
                case 1:
                  this.currentValues.FAT--;
                  break;
                case 2:
                  this.currentValues.PRO--;
                  break;
              }
              carbChoice++;
              carbChoice = carbChoice % 3;
              totalRatioSet--;
              counter--;
            }
          }

          this.setupRatios();
        }
      //}
    }
    
    
  }

  calculateCRBPoints(value) {
    return value;
  }

  calculatePROPoints(value) {
    return value;
  }

  calculateFATPoints(value) {
    return value;
  }

  reviewData() {
    if (this.currentValues.MACRORATIO == 100 && !!this.currentValues.BMR && !!this.currentValues.TDEE && !!this.currentValues.targetCalories) {
      $(".macro-calc-button").prop("disabled", false);
    } else {
      $(".macro-calc-button").prop("disabled", true);
    }
  }

  setupEventListeners() {
    console.log('Setup Event Listener');
    const ageSelect = document.querySelector('input[name="age"]');
    const genderSelect = document.querySelector('select[name="gender"]');
    const heightToggles = document.querySelectorAll('.height-toggle');
    const weightToggles = document.querySelectorAll('.weight-toggle');
    const goalToggles = document.querySelectorAll('.goal-toggle');
    const exerciseToggles = document.querySelectorAll('.exercise-toggle');
    //const bodyRecompToggle = document.querySelectorAll('input[data-option-id="body-recomposition"]');
    const bodyFatSelect = document.querySelector('input[name="body-recomp-percent"]');

    if (genderSelect) {
      this.currentValues.bodyFat = ((this.currentValues.gender == 'male') ? 20 : 22);
      $('input[name="body-recomp-percent"]').val(this.currentValues.bodyFat);
      this.updateBodyFatRate();
      genderSelect.addEventListener('change', (e) => {
        this.currentValues.gender = e.target.value;
        this.currentValues.bodyFat = ((this.currentValues.gender == 'male') ? 20 : 22);
        $('input[name="body-recomp-percent"]').val(this.currentValues.bodyFat);
        this.updateBodyFatRate();
      });
    }

    if (ageSelect) {
      ageSelect.addEventListener('input', (e) => {
        this.currentValues.age = parseInt(e.target.value);
        
        this.checkAge();
        this.checkBMR();
      });
    }

    $('input[name="height-feet"]')[0].addEventListener('input', (e) => {
        this.checkHeight();
        this.checkBMR();
      });

      $('input[name="height-inches"]')[0].addEventListener('input', (e) => {
        this.checkHeight();
        this.checkBMR();
      });

      $('input[name="height-centimeters"]')[0].addEventListener('input', (e) => {
        this.checkHeight();
        this.checkBMR();
      });

      $('input[name="weight-pounds"]')[0].addEventListener('input', (e) => {
        this.checkWeight();
        this.checkBMR();
      });

      $('input[name="weight-kilograms"]')[0].addEventListener('input', (e) => {
        this.checkWeight();
        this.checkBMR();
      });

      $('input[name="goal-pounds"]')[0].addEventListener('input', (e) => {
        this.checkTargetWeight();
      });

      $('input[name="goal-kilograms"]')[0].addEventListener('input', (e) => {
        this.checkTargetWeight();
      });

      $('input[name="goal-weeks"]')[0].addEventListener('input', (e) => {
        this.checkTargetWeeks();
      });

    // [Height Toggle Listener]
    heightToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => { 
        if (!e.currentTarget.classList.contains('event-selected')) {
          e.currentTarget.classList.add("event-selected");
        }

        if (e.currentTarget.dataset.optionId == 'cm') {
          this.toggleHeightInputs(true);
        } else {
          this.toggleHeightInputs(false);
        }

        heightToggles.forEach(otherToggle => {
          if (otherToggle !== e.currentTarget) otherToggle.classList.remove('event-selected');
        });

        this.checkHeight();
        this.checkBMR();
      });
    });

    // [Weight Toggle Listener]
    weightToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => { 
        if (!e.currentTarget.classList.contains('event-selected')) {
          e.currentTarget.classList.add("event-selected");
        }

        if (e.currentTarget.dataset.optionId == 'kg') {
          this.toggleWeightInputs(true);
        } else {
          this.toggleWeightInputs(false);
        }

        weightToggles.forEach(otherToggle => {
          if (otherToggle !== e.currentTarget) otherToggle.classList.remove('event-selected');
        });

        this.checkWeight();
        this.checkTargetWeight();
        this.checkBMR();
      });
    });

    // [Goals Listener]
    goalToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => { 
        if (!e.currentTarget.classList.contains('event-selected')) {
          e.currentTarget.classList.add("event-selected");
        }

        if (e.currentTarget.dataset.optionId == "weight-loss") {
            this.toggleGoals("weight-loss");
        } else if (e.currentTarget.dataset.optionId == "muscle-gain") {
            this.toggleGoals("muscle-gain");
        } else if (e.currentTarget.dataset.optionId == "body-recomp-route") {
            this.toggleGoals("body-recomp-route");
        }

        goalToggles.forEach(otherToggle => {
          if (otherToggle !== e.currentTarget) otherToggle.classList.remove('event-selected');
        })

        this.checkCalorieGoal();
      });
    });

    // [Exercise Listener]
    exerciseToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => { 
        if (!e.currentTarget.classList.contains('event-selected')) {
          e.currentTarget.classList.add("event-selected");
        }

        this.toggleExercise(e.currentTarget.getAttribute("value"));

        exerciseToggles.forEach(otherToggle => {
          if (otherToggle !== e.currentTarget) otherToggle.classList.remove('event-selected');
        })

        this.checkTDEE();
      });
    });

    /*bodyRecompToggle.forEach(toggle => {
      if (toggle.checked) {
        $('input[name="body-recomp-percent"]').prop("disabled", false);
        $('.body-recomposition-details').css('background-color', this.exerciseColors[3]);
        $('div.body-recomposition-details > p').css('color', "#ffffff");
      } else {
        $('input[name="body-recomp-percent"]').prop("disabled", true);
        $('.body-recomposition-details').css('background-color', 'rgb(207, 207, 207)');
        $('div.body-recomposition-details > p').css('color', "#5f5f5f");
      }
      toggle.addEventListener('change', (e) => { 

        if (e.currentTarget.checked) {
          $('input[name="body-recomp-percent"]').prop("disabled", false);
          $('.body-recomposition-details').css('background-color', this.exerciseColors[3]);
          $('div.body-recomposition-details > p').css('color', "#ffffff");
        } else {
          $('input[name="body-recomp-percent"]').prop("disabled", true);
          $('.body-recomposition-details').css('background-color', 'rgb(207,207,207)');
          $('div.body-recomposition-details > p').css('color', "#5f5f5f");
        }
      });
    });*/

    // [Body Fat Listener]
    if (bodyFatSelect) {
      bodyFatSelect.addEventListener('input', (e) => {
        this.currentValues.bodyFat = e.target.value;
        this.updateBodyFatRate();
        this.checkTDEE();
      });
    }

    // Listener entered input alt event
    /*const altInputs = document.querySelectorAll(".mmss-input");
    if (altInputs) {
      altInputs.forEach(el => {
        el.addEventListener('input', e => {
          const current = e.currentTarget;
          
          // Jika input ini berisi nilai (meskipun belum lengkap)
          if (current.value.trim() !== '') {
              // Langsung set sebagai selected alternate event
              this.currentValues.selectedAlternateEvent = current;
              console.log('Selected Alternate Event:', {
                  element: current,
                  dataset: current.dataset,
                  name: current.dataset.name
              });
              
              // Disable dan clear input lain
              altInputs.forEach(other => {
                  if (other !== current) {
                      other.disabled = true;
                      other.value = '';
                  }
              });
          } else {
              // Jika input dikosongkan, aktifkan semua input lain
              altInputs.forEach(other => {
                  other.disabled = false;
              });
              
              // Cek apakah masih ada input lain yang berisi nilai
              const activeInput = Array.from(altInputs).find(input => 
                  input !== current && input.value.trim() !== ''
              );
              
              if (activeInput) {
                  // Set input lain yang masih berisi nilai sebagai selected
                  this.currentValues.selectedAlternateEvent = activeInput;
              } else {
                  // Tidak ada input yang berisi nilai, reset
                  this.currentValues.selectedAlternateEvent = null;
                  this.currentValues['2MR'] = { min: 0, sec: 0 };
              }
          }
          
          // Update display setelah selectedAlternateEvent diset
          this.updateAlternateRunStandardDisplay();
          
          // Jika input berisi format waktu yang valid, update nilai dan score
          if (current.value.includes(':')) {
              const [altMinutes, altSeconds] = current.value.split(':');
              const altMin = parseInt(altMinutes) || 0;
              const altSec = parseInt(altSeconds) || 0;
              console.log('Parsed time:', { altMinutes, altSeconds, altMin, altSec });
              this.currentValues['2MR'] = { min: altMin, sec: altSec };
          } else if (current.value.trim() === '') {
              this.currentValues['2MR'] = { min: 0, sec: 0 };
          }
          
          this.updateScore('2MR');
          
          // Update progress bars jika result sedang ditampilkan
          const resultBlock = document.querySelector('.result');
          if (resultBlock && !resultBlock.classList.contains('result--hidden')) {
              this.updateProgressBars();
          }
        });
        
        // Tambahkan event listener untuk focus - untuk clear input lain ketika focus
        el.addEventListener('focus', e => {
          const current = e.currentTarget;
          
          // Jika ada input lain yang berisi nilai, clear mereka
          altInputs.forEach(other => {
            if (other !== current && other.value.trim() !== '') {
              other.value = '';
              other.disabled = false; // Enable dulu sebelum disable untuk menghindari konflik
              setTimeout(() => {
                other.disabled = true;
              }, 0);
            }
          });
          
          // Set sebagai selected jika belum
          if (this.currentValues.selectedAlternateEvent !== current) {
            this.currentValues.selectedAlternateEvent = current;
            this.updateAlternateRunStandardDisplay();
            
            // Update progress bars jika result sedang ditampilkan
            const resultBlock = document.querySelector('.result');
            if (resultBlock && !resultBlock.classList.contains('result--hidden')) {
              this.updateProgressBars();
            }
          }
        });
      });
    }*/

    // Calculate button
    const recommendBtn = document.querySelector('.macro-recommend-button:not(.macro-recommend-button--light)');
    if (recommendBtn) {
      recommendBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.refreshRatios();
        return false;
      });
    }

    // Calculate button
    const calculateBtn = document.querySelector('.macro-calc-button:not(.macro-calc-button--light)');
    if (calculateBtn) {
      calculateBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.showResults();
        return false;
      });
    }

    // Reset button
    /*const resetBtn = document.querySelector('.calc-button--light');
    if (resetBtn) {
      resetBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.resetForm();
      });
    }*/

      
  }

    calculateMacros() {
      return false;
    }

  capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  showResults() {

    $("#macro-result-age").html(this.currentValues.age);
    $("#macro-result-gender").html(this.capitalizeFirstLetter(this.currentValues.gender));
    $("#macro-result-height").html((this.currentValues.useHeight ? (this.currentValues.cm + " cm.") : ($('input[name="height-feet"]').val() + " ft. " + $('input[name="height-inches"]').val() + " in. ")));
    $("#macro-result-weight").html((this.currentValues.useWeight ? (this.currentValues.kg + " kg.") : ($('input[name="weight-pounds"]').val() + " lbs. ")));
    if (this.currentValues.selectedGoal == "weight-loss") {
      $("#macro-result-target-goal").html("lose weight:");
    } else if (this.currentValues.selectedGoal == "muscle-gain") {
      $("#macro-result-target-goal").html("gain muscle:");
    } else if (this.currentValues.selectedGoal == "body-recomp-route") {
      $("#macro-result-target-goal").html("maintain muscle while losing body fat:");
    }
    $("#macro-result-target-weight").html((this.currentValues.useWeight ? (this.currentValues.targetWeight + " kg.") : (this.currentValues.targetWeightLbs + " lbs.")));
    $("#macro-result-target-weeks").html(this.currentValues.targetWeeks + " weeks");
    $("#macro-result-exercise").html(this.exerciseDetails[this.currentValues.selectedExercise]);
    $("#macro-result-daily-calories").html(this.currentValues.targetCalories);

    let carbGrams = parseInt(Math.round((this.currentValues.targetCalories * (this.currentValues.CRB) / 100)) / 4);
    let proteinGrams = parseInt(Math.round((this.currentValues.targetCalories * (this.currentValues.PRO) / 100)) / 4);
    let fatGrams = parseInt(Math.round((this.currentValues.targetCalories * (this.currentValues.FAT) / 100)) / 9);
    $("#macro-result-carbs").html(carbGrams);
    $("#macro-result-protein").html(proteinGrams);
    $("#macro-result-fats").html(fatGrams);
    
    let resultDonutLayout = {
      /*title: {
        text: 'Macros',
        y: 0.1,
      },*/
      paper_bgcolor: 'transparent',
      annotations: [
        {
          font: {
            size: 20
          },
          showarrow: false,
          text: '',
          x: 0.17,
          y: 0.5
        }
      ],
      margin: {
        t: 1,
        //b: 100,
        l:1,
        r:1,
        pad: 50,
      },
      automargin: false,
      autosize: true,
      height: 300,
      //minreducedwidth: 200,
      width: parseInt(Math.floor($(".macro-chart-container-result").width())),
      showlegend: false
    };

    let resultDonutData = [{
      values: [this.currentValues.CRB, this.currentValues.PRO, this.currentValues.FAT],
      labels: ['Carbs', 'Proteins', 'Fats' ],
      marker: { colors: ['#ff7733', '#cc0000', '#880022']},
      domain: {column: 0},
      sort: false, 
      name: 'Macronutrient Ratio',
      textinfo: 'label+percent',
      hoverinfo: 'label+percent',
      hole: .4,
      pull: 0.02,
      type: 'pie'
    }];

    let imgDonutLayout = {
        paper_bgcolor: '#525e56',
        annotations: [
          {
            font: {
              size: 20
            },
            showarrow: false,
            text: '',
            x: 0.17,
            y: 0.5
          }
        ],
        margin: {
          t: 50,
          l:1,
          r:1,
          b: 10,
          pad: 10,
        },
        title: {
          text:'Macro Ratio Chart',
          font: {
            family: 'sans-serif',
            size: 24,
            color: '#ffffff'
          },
          xanchor: "center"
        },
        automargin: false,
        //autosize: true,
        height: 300,
        width: 400,
        showlegend: false
      };


      var img_png= d3.select('#png-export');

    setTimeout(() => {
    Plotly.newPlot('macroRatioChart-result', resultDonutData, resultDonutLayout);
    Plotly.newPlot('macroRatioChartB', resultDonutData, imgDonutLayout)
      .then(function(gd) {
        Plotly.toImage(gd,{format:'png',height:300,width:400})
        .then(

             function(url)

         {

             img_png.attr("src", url);

         }

         )

    });
    Plotly.redraw('macroRatioChart-result');
    }, 200);

    /*let bmrResult = this.currentValues.BMR;
    let activityMultiplierResult = this.activityMultipliers[this.currentValues.selectedExercise];
    let dailyRequirementResult = parseFloat((bmrResult * activityMultiplierResult).toFixed(2));

    let goalAmount;
    let goalAmountLbs;
    if (this.currentValues.selectedGoal == "weight-loss") {
      if (!this.currentValues.useWeight) {
        goalAmount = Math.round($('input[name="weight-pounds"]').val() - $('input[name="goal-pounds"]').val()) / 2.205;
        goalAmountLbs = Math.round($('input[name="weight-pounds"]').val() - $('input[name="goal-pounds"]').val());
      } else {
        goalAmount = Math.round($('input[name="weight-kilograms"]').val() - $('input[name="goal-kilograms"]').val());
        goalAmountLbs = Math.round($('input[name="weight-kilograms"]').val() - $('input[name="goal-kilograms"]').val()) * 2.205;
      }
    } else {
      if (!this.currentValues.useWeight) {
        goalAmount = Math.round($('input[name="goal-pounds"]').val() - $('input[name="weight-pounds"]').val()) / 2.205;
        goalAmountLbs = Math.round($('input[name="goal-pounds"]').val() - $('input[name="weight-pounds"]').val());
      } else {
        goalAmount = Math.round($('input[name="goal-kilograms"]').val() - $('input[name="weight-kilograms"]').val());
        goalAmountLbs = Math.round($('input[name="goal-kilograms"]').val() - $('input[name="weight-kilograms"]').val()) * 2.205;
      }
    }

    let dailyAmt;
    let dailyAmtLbs;
    dailyAmt = goalAmount / (($('input[name="goal-weeks"]').val() > 0) ? ($('input[name="goal-weeks"]').val() * 7) : 7);
    dailyAmtLbs = goalAmountLbs / (($('input[name="goal-weeks"]').val() > 0) ? ($('input[name="goal-weeks"]').val() * 7) : 7);

    let calorieAmt;
    calorieAmt = Math.round(500 * (dailyAmt * 2.205) * 7);
    
    let newDailyCalories = dailyRequirementResult - calorieAmt;

    let newCarbAmt = (newDailyCalories * (this.currentValues.CRB / 100)) / 4;
    let newProteinAmt = (newDailyCalories * (this.currentValues.PRO / 100)) / 4;
    let newFatAmt = (newDailyCalories * (this.currentValues.FAT / 100)) / 9;

    console.log("BMR: " + bmrResult);
    console.log("Activity Multiplier: " + activityMultiplierResult);
    console.log("Daily Requirement: " + dailyRequirementResult);
    console.log("Daily Amount: " + dailyAmt + " kgs per day");
    console.log("Daily Amount: " + dailyAmtLbs + " lbs per day");
    console.log("Subtracted Calorie Amount: " + calorieAmt + " calories per day");
    console.log("New Daily Calorie Amount: " + newDailyCalories + " calories per day");
    console.log("Daily Carbs: " + newCarbAmt + " grams per day");
    console.log("Daily Proteins: " + newProteinAmt + " grams per day");
    console.log("Daily Fats: " + newFatAmt + " grams per day");*/

    /*const totalScore = Object.values(this.scores).reduce((sum, score) => sum + score, 0);
    const maxScore = 500;
    const percentage = Math.round((totalScore / maxScore) * 100);
    // Update total score
    const scoreElement = document.querySelector('.total__score');
    const percentElement = document.querySelector('.total__percent');

    if (scoreElement) scoreElement.textContent = totalScore;
    if (percentElement) percentElement.textContent = percentage;

    const allEventsPassedMinimum = Object.values(this.scores).every(score => score >= 60);

    // Tentukan kategori hasil (60 points per event minimum untuk 5 events = 300)
    let category = 'FAILED';
    let categoryClass = 'category--failed';
    if (this.currentValues.gender == 'combat') {
      if (totalScore >= 350 && allEventsPassedMinimum) { // 60 points per event minimum untuk 5 events
        category = 'PASSED';
        categoryClass = 'category--passed';
      }
    } else {
      if (totalScore >= 300) {
        category = 'PASSED';
        categoryClass = 'category--passed';
      }
    }


    const categoryElement = document.querySelector('.result__cat-name');
    if (categoryElement) {
      categoryElement.textContent = category;
      categoryElement.className = `category total__row-value result__cat-name ${categoryClass}`;
    }
    this.updateOmniInputs();
    this.updateProgressBars();

    */

    this.updateOmniInputs(carbGrams, proteinGrams, fatGrams);

    const resultBlock = document.querySelector('.result-macro');
    if (resultBlock) {
      resultBlock.classList.remove('result--hidden');

      setTimeout(() => {
        resultBlock.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      });
    }
  }

  updateOmniInputs(carbGrams, proteinGrams, fatGrams) {

    let heightResult = ((this.currentValues.useHeight ? parseInt(this.currentValues.cm) : (parseInt($('input[name="height-feet"]').val() * 12) + parseInt($('input[name="height-inches"]').val()))));
    let weightResult = ((this.currentValues.useWeight ? parseInt(this.currentValues.kg) : (parseInt($('input[name="weight-pounds"]').val()))));
    let weightGoalResult = ((this.currentValues.useWeight ? parseInt(this.currentValues.targetWeight) : parseInt(this.currentValues.targetWeightLbs)));

    console.log("Omni: " + window.omniInputs);

    console.log("Omni: " + window.omniInputs.macro_gender);

    if(window.omniInputs) {
      if(window.omniInputs.macro_standard) window.omniInputs.macro_standard.value = this.currentValues.gender;
      if(window.omniInputs.macro_age) window.omniInputs.macro_age.value = this.currentValues.age;
      if(window.omniInputs.macro_gender) window.omniInputs.macro_gender.value = this.capitalizeFirstLetter(this.currentValues.gender);
      if(window.omniInputs.macro_height) window.omniInputs.macro_height.value = heightResult;
      if(window.omniInputs.macro_height_format) window.omniInputs.macro_height_format.value = (this.currentValues.useHeight ? "cm" : "in");
      if(window.omniInputs.macro_weight) window.omniInputs.macro_weight.value = weightResult;
      if(window.omniInputs.macro_weight_format) window.omniInputs.macro_weight_format.value = (this.currentValues.useWeight ? "kg" : "lb");
      if(window.omniInputs.macro_target_goal) window.omniInputs.macro_target_goal.value = this.currentValues.selectedGoal;
      if(window.omniInputs.macro_target_weight) window.omniInputs.macro_target_weight.value = weightGoalResult;
      if(window.omniInputs.macro_target_weeks) window.omniInputs.macro_target_weeks.value = this.currentValues.targetWeeks;
      if(window.omniInputs.macro_exercise) window.omniInputs.macro_exercise.value = this.exerciseDetails[this.currentValues.selectedExercise];
      if(window.omniInputs.macro_daily_calories) window.omniInputs.macro_daily_calories.value = this.currentValues.targetCalories;
      if(window.omniInputs.macro_carbs) window.omniInputs.macro_carbs.value = carbGrams;
      if(window.omniInputs.macro_protein) window.omniInputs.macro_protein.value = proteinGrams;
      if(window.omniInputs.macro_fats) window.omniInputs.macro_fats.value = fatGrams;
      console.log("Omni: " + window.omniInputs);

      console.log("Omni Value Age: " + window.omniInputs.macro_age);
      console.log("Omni Value Age: " + window.omniInputs.macro_age.value);

      console.log("Omni Value Age Again: " + $('input[name="custom_custom_macro_age"]').val());
    }

    console.log("Update omnisend inputs...: ", window.omniInputs);
  }

  toggleHeightInputs(activateHeight) {
    const cmElement = document.querySelector('[data-field-id="cm"]');
    const ftElement = document.querySelector('[data-field-id="ft"]');
    this.currentValues.useHeight = activateHeight; // bool

    if(activateHeight) {
        if(ftElement) ftElement.style.display = 'none';
        if(cmElement) cmElement.style.display = 'block';
    } else {
        if(ftElement) ftElement.style.display = 'block';
        if(cmElement) cmElement.style.display = 'none';
    }
  }

  toggleWeightInputs(activateWeight) {
    const kgElement = document.querySelector('[data-field-id="kg"]');
    const lbsElement = document.querySelector('[data-field-id="lbs"]');
    const kgElement2 = document.querySelector('[data-field-id="kg-2"]');
    const lbsElement2 = document.querySelector('[data-field-id="lbs-2"]');
    this.currentValues.useWeight = activateWeight; // bool

    if(activateWeight) {
        if(lbsElement) lbsElement.style.display = 'none';
        if(kgElement) kgElement.style.display = 'block';
    } else {
        if(lbsElement) lbsElement.style.display = 'block';
        if(kgElement) kgElement.style.display = 'none';
    }

    if(activateWeight) {
        if(lbsElement2) lbsElement2.style.display = 'none';
        if(kgElement2) kgElement2.style.display = 'block';
    } else {
        if(lbsElement2) lbsElement2.style.display = 'block';
        if(kgElement2) kgElement2.style.display = 'none';
    }
  }

  toggleGoals(activateGoal) {
    const weightLossElement = document.querySelector('[data-field-id="weight-loss"]');
    const muscleGainElement = document.querySelector('[data-field-id="muscle-gain"]');
    const bodyRecompRouteElement = document.querySelector('[data-field-id="body-recomp-route"]');
    const bodyRecompElement = document.querySelector('.body-recomp-section');
    this.currentValues.selectedGoal = activateGoal; // value

    if(activateGoal == "weight-loss") {
        if(muscleGainElement) muscleGainElement.style.display = 'none';
        if(weightLossElement) weightLossElement.style.display = 'block';
        if(bodyRecompRouteElement) bodyRecompRouteElement.style.display = 'none';
        if(bodyRecompElement) bodyRecompElement.style.display = 'none';
        this.currentValues.useBodyFat = false;
        $(".recommend-amt").html(' LESS ');
        this.checkBMR();
    } else if(activateGoal == "muscle-gain") {
        if(weightLossElement) weightLossElement.style.display = 'none';
        if(muscleGainElement) muscleGainElement.style.display = 'block';
        if(bodyRecompRouteElement) bodyRecompRouteElement.style.display = 'none';
        if(bodyRecompElement) bodyRecompElement.style.display = 'none';
        this.currentValues.useBodyFat = false;
        $(".recommend-amt").html(' MORE ');
        this.checkBMR();
    } else {
        if(muscleGainElement) muscleGainElement.style.display = 'none';
        if(weightLossElement) weightLossElement.style.display = 'none';
        if(bodyRecompRouteElement) bodyRecompRouteElement.style.display = 'block';
        if(bodyRecompElement) bodyRecompElement.style.display = 'block';
        this.currentValues.useBodyFat = true;
        $(".recommend-amt").html(' LESS ');
        this.checkBMR();
    }
  }

  toggleExercise(activateExercise) {

    this.currentValues.selectedExercise = activateExercise;

    $("div .exercise-details").css("background-color", this.exerciseColors[activateExercise]);
    $("div .exercise-details > p").html(this.exerciseDetails[activateExercise]);

    //if ($())
  }

  updateBodyFatRate() {
    let genderOfBodyFat;
    let determinedBodyFat = this.currentValues.bodyFat;
    if (this.currentValues.gender == 'male') {
      genderOfBodyFat = this.bodyFatRateMale;
    } else {
      genderOfBodyFat = this.bodyFatRateFemale;
    }

    for (let i = 0; i < 5; i++) {
      if (determinedBodyFat >= genderOfBodyFat[i]) {
        $("div.body-recomposition-details-label > p").html("Category: " + this.bodyFatDetailLabels[i]);
      } else {
        break;
      }
    }

    for (let i = 0; i < 5; i++) {
      if (determinedBodyFat >= genderOfBodyFat[i]) {
        $("div.body-recomposition-details > p").html(this.bodyFatDetails[this.currentValues.gender][i]);
      } else {
        break;
      }
    }
    
  }
}




window.addEventListener('load', () => {

  // Code for time input Alt--Events!!
  const timeInputs = document.querySelectorAll('.mmss-input');
  const timeError = document.getElementById('timeInputError');

  timeInputs.forEach(input => {
    input.addEventListener('input', function() {
      let value = this.value.replace(/[^0-9]/g, '');
      if (value.length > 4) value = value.slice(0, 4);

      if (value.length <= 2) {
        this.value = value;
      } else {
        this.value = value.slice(0, value.length - 2) + ':' + value.slice(-2);
      }
    });

    input.addEventListener('blur', function() {
      const value = this.value.trim();
      timeError.textContent = '';

      if (value === "") return;

      const parts = value.split(':');
      if (parts.length !== 2) {
        timeError.textContent = `Wrong time format ${this.name}. use MM:SS.`;
        return;
      }

      const [minutesStr, secondsStr] = parts;
      if (!/^\d{1,2}$/.test(minutesStr) || !/^\d{1,2}$/.test(secondsStr)) {
        timeError.textContent = `Wrong time format ${this.name}. use MM:SS.`;
        return;
      }

      const minutes = parseInt(minutesStr, 10);
      const seconds = parseInt(secondsStr, 10);
      if (minutes < 0 || minutes > 59 || seconds < 0 || seconds > 59) {
        timeError.textContent = `Invalid time ${this.name}. use example: 00–59.`;
        return;
      }

      this.value = String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
    });
  });

  // Delay untuk memastikan semua library sudah dimuat
  setTimeout(() => {
    window.macroCalculator = new MacroCalculator();
    $(".calc-form-loading").css("display", "none");
    $(".calc-form").css("display", "block");
  }, 2000); console.log("Loaded!")

  window.addEventListener('resize', function(event) {

  
    let newDonutData = donutData = [{
          values: [macroCalculator.currentValues.CRB, macroCalculator.currentValues.PRO, macroCalculator.currentValues.FAT],
          labels: ['Carbs', 'Proteins', 'Fats' ],
          marker: { colors: ['#ff7733', '#cc0000', '#880022']},
          domain: {column: 0},
          sort: false, 
          name: 'Macronutrient Ratio',
          textinfo: 'label+percent',
          hoverinfo: 'label+percent',
          hole: .4,
          pull: 0.02,
          type: 'pie'
        }];

        let newDonutLayout = {
          paper_bgcolor: 'transparent',
          annotations: [
            {
              font: {
                size: 20
              },
              showarrow: false,
              text: '',
              x: 0.17,
              y: 0.5
            }
          ],
          margin: {
            t: 1,
            l:1,
            r:1,
            pad: 50,
          },
          automargin: false,
          autosize: true,
          height: 300,
          width: parseInt(Math.floor($(".macro-chart-container").width())),
          showlegend: false
        };

        let newDonutLayout2 = {
          paper_bgcolor: 'transparent',
          annotations: [
            {
              font: {
                size: 20
              },
              showarrow: false,
              text: '',
              x: 0.17,
              y: 0.5
            }
          ],
          margin: {
            t: 1,
            l:1,
            r:1,
            pad: 50,
          },
          automargin: false,
          autosize: true,
          height: 300,
          width: parseInt(Math.floor($(".macro-chart-container-result").width())),
          showlegend: false
        };

        Plotly.newPlot('macroRatioChart', newDonutData, newDonutLayout);
        Plotly.redraw('macroRatioChart');

        setTimeout(() => {
          Plotly.newPlot('macroRatioChart', newDonutData, newDonutLayout);
          Plotly.redraw('macroRatioChart');
        }, 100);

        if (!$(".result-macro").hasClass("result--hidden")) {
          Plotly.newPlot('macroRatioChart-result', newDonutData, newDonutLayout2);
          Plotly.redraw('macroRatioChart-result');
          setTimeout(() => {
            Plotly.newPlot('macroRatioChart-result', newDonutData, newDonutLayout2);
            Plotly.redraw('macroRatioChart-result');
          }, 100);
        }
}, true);


});